// eslint-disable-next-line import/prefer-default-export
export const divideArrayIntoSubArrays = (array, numberOfSubArrays) => {
  const subArraySize = Math.ceil(array.length / numberOfSubArrays);
  const subArrays = [];

  for (let i = 0; i < array.length; i += subArraySize) {
    subArrays.push(array.slice(i, i + subArraySize));
  }

  return subArrays;
};
